import { z } from 'zod'

const UrlSchema = z
  .string()
  .url()
  // Remove trailing slashes (incl. before a ?query / #fragment) and duplicate slashes except for the "://" part
  .transform((url) => url.replace(/\/+(?=[?#]|$)/, '').replace(/([^:]\/)\/+/g, '$1'))

export const sanitizeUrl = (maybeUrl: string) => {
  const { success, data } = UrlSchema.safeParse(maybeUrl)

  if (success) {
    return data
  }

  return maybeUrl
}
